/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_ExtractedInputs */

const en_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI EXTRACTED`)
};

const es_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXTRAÍDO POR IA`)
};

const fr_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXTRAIT PAR IA`)
};

const de_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-EXTRAHIERT`)
};

const ja_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI抽出`)
};

const zh_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 提取`)
};

const ar_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستخرج بواسطة الذكاء الاصطناعي`)
};

const id_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DIEKSTRAK AI`)
};

const it_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESTRATTO DALL'IA`)
};

const ru_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИЗВЛЕЧЕНО ИИ`)
};

const pt_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EXTRAÍDO POR IA`)
};

const ko_ai_extracted = /** @type {(inputs: Ai_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 추출됨`)
};

/**
* | output |
* | --- |
* | "AI EXTRACTED" |
*
* @param {Ai_ExtractedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_extracted = /** @type {((inputs?: Ai_ExtractedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_ExtractedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_extracted(inputs)
	if (locale === "es") return es_ai_extracted(inputs)
	if (locale === "fr") return fr_ai_extracted(inputs)
	if (locale === "de") return de_ai_extracted(inputs)
	if (locale === "ja") return ja_ai_extracted(inputs)
	if (locale === "zh") return zh_ai_extracted(inputs)
	if (locale === "ar") return ar_ai_extracted(inputs)
	if (locale === "id") return id_ai_extracted(inputs)
	if (locale === "it") return it_ai_extracted(inputs)
	if (locale === "ru") return ru_ai_extracted(inputs)
	if (locale === "pt") return pt_ai_extracted(inputs)
	return ko_ai_extracted(inputs)
});